import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["textarea", "container"];

  connect() {
    // Initialize any necessary state
    console.log("Zen mode controller connected");

    // Add global event listener for Escape key
    this.boundHandleEscapeKey = this.handleEscapeKey.bind(this);
    document.addEventListener("keydown", this.boundHandleEscapeKey, {
      capture: true,
    });
  }

  disconnect() {
    // Clean up event listener when controller is disconnected
    document.removeEventListener("keydown", this.boundHandleEscapeKey, {
      capture: true,
    });
  }

  // Handle Escape key globally with capture phase to ensure it runs first
  handleEscapeKey(event) {
    if (
      (event.key === "Escape" || event.key === "Esc") &&
      document.documentElement.hasAttribute("data-zen-mode")
    ) {
      // Prevent other handlers from firing
      event.stopPropagation();
      event.preventDefault();
      this.toggle();
      return false;
    }
  }

  // Method that can be called directly from the view
  closeWithEscape() {
    const isZenMode = document.documentElement.hasAttribute("data-zen-mode");
    const textarea = this.textareaTarget;

    if (!isZenMode) {
      return;
    }

    document.documentElement.removeAttribute("data-zen-mode");
    document.body.classList.remove("overflow-hidden");

    // Reset textarea size
    textarea.style.height = "";
    textarea.style.maxHeight = "";

    // Focus back on textarea
    textarea.focus();
  }

  toggle() {
    const textarea = this.textareaTarget;
    const isZenMode = document.documentElement.hasAttribute("data-zen-mode");

    if (isZenMode) {
      // Exit zen mode
      document.documentElement.removeAttribute("data-zen-mode");
      document.body.classList.remove("overflow-hidden");

      // Reset textarea size
      textarea.style.height = "";
      textarea.style.maxHeight = "";

      // Focus back on textarea
      textarea.focus();
    } else {
      // Enter zen mode
      document.documentElement.setAttribute("data-zen-mode", "");
      document.body.classList.add("overflow-scroll");

      // Make textarea full height
      requestAnimationFrame(() => {
        textarea.style.height = "90dvh";
        const isIOS =
          /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        textarea.style.maxHeight = isIOS
          ? "calc(48dvh - env(keyboard-inset-height, 46px))"
          : "90dvh";
        textarea.style.overflow = "scroll";
        textarea.focus();
        textarea.focus();
      });
      textarea.focus();
    }
  }

  // Close zen mode when clicking outside the container
  closeOnOutsideClick(event) {
    if (
      document.documentElement.hasAttribute("data-zen-mode") &&
      !this.containerTarget.contains(event.target)
    ) {
      this.toggle();
    }
  }
}
